(function () {
  function initGallery() {
    const wrapper = document.querySelector('media-gallery');
    if (!wrapper) return;

    wrapper.style.position = 'relative';

    function createBtn(symbol, label, side) {
      const btn = document.createElement('button');
      btn.innerHTML = symbol;
      btn.setAttribute('aria-label', label);
      btn.style.cssText = `
        position: absolute;
        ${side}: 16px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 20;
        background: transparent;
        border: none;
        padding: 8px;
        cursor: pointer;
        color: #222;
        font-size: 28px;
        font-weight: 300;
        line-height: 1;
        opacity: 0.6;
        transition: opacity 0.2s;
        font-family: serif;
        display: none;
      `;
      btn.addEventListener('mouseenter', () => btn.style.opacity = '1');
      btn.addEventListener('mouseleave', () => btn.style.opacity = '0.6');
      return btn;
    }

    const prevBtn = createBtn('&#8249;', 'Vorheriges Bild', 'left');
    const nextBtn = createBtn('&#8250;', 'Nächstes Bild', 'right');
    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);

    // Pfeile nur auf Desktop anzeigen
    function updateBtnVisibility() {
      const isDesktop = window.innerWidth >= 750;
      prevBtn.style.display = isDesktop ? 'flex' : 'none';
      nextBtn.style.display = isDesktop ? 'flex' : 'none';
    }
    updateBtnVisibility();
    window.addEventListener('resize', updateBtnVisibility);

    function getThumbs() {
      return Array.from(document.querySelectorAll('.thumbnail-list__item button'));
    }

    function getActiveIndex() {
      const slides = Array.from(document.querySelectorAll('.product__media-item'));
      const activeIdx = slides.findIndex(s => s.classList.contains('is-active'));
      return activeIdx >= 0 ? activeIdx : 0;
    }

    function navigate(dir) {
      const thumbs = getThumbs();
      if (!thumbs.length) return;
      let idx = getActiveIndex();
      idx = (idx + dir + thumbs.length) % thumbs.length;
      thumbs[idx].click();
    }

    prevBtn.addEventListener('click', (e) => { e.stopPropagation(); navigate(-1); });
    nextBtn.addEventListener('click', (e) => { e.stopPropagation(); navigate(1); });

    // Touch Mobile
    const mediaList = document.querySelector('.product__media-list');
    let startX = 0, startY = 0;
    mediaList?.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    mediaList?.addEventListener('touchend', (e) => {
      const diffX = startX - e.changedTouches[0].clientX;
      const diffY = startY - e.changedTouches[0].clientY;
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
        navigate(diffX > 0 ? 1 : -1);
      }
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', initGallery);
})();






